import {makeAutoObservable} from 'mobx';
import {getAbFlags, calculateSingleFlag, getFlagSchemaByName} from '@amplify/abflag';
import {AppAbFlag} from '@amplify/athena-models';
import backupAbFlagResult from '../utils/backupAbFlagResult';

export class ABFlagsStore {
    flags: Record<string, boolean | string> = {};
    flagScheme: AppAbFlag[] = [];
    isInitialized = false;

    constructor() {
        makeAutoObservable(this);
    }

    initializeFlags(abFlagScheme?: AppAbFlag[]) {
        // Use provided schema or fall back to backup
        const schemaToUse = abFlagScheme && abFlagScheme.length > 0 ? abFlagScheme : backupAbFlagResult;

        this.flagScheme = schemaToUse;
        this.flags = getAbFlags(schemaToUse);
        this.isInitialized = true;
        console.log('AB Flags initialized:', this.flags);
    }

    getFlag(flagName: string): boolean | string | undefined {
        return this.flags[flagName];
    }

    updateFlag(flagName: string, value: boolean | string) {
        this.flags[flagName] = value;
    }

    calculateFormFlag(flagName: string, formId: string): boolean | string {
        const flagSchema = getFlagSchemaByName(this.flagScheme, flagName);
        if (!flagSchema) {
            console.warn(`Flag ${flagName} not found in schema`);
            return false;
        }

        const probabilityTrue = (flagSchema as any).probabilityTrue;
        const categories = (flagSchema as any).categories;

        return calculateSingleFlag(flagName, probabilityTrue, categories, formId);
    }

    calculateFlagsForForm(flagNames: string[], formId: string): Record<string, boolean | string> {
        const formFlags: Record<string, boolean | string> = {};

        for (const flagName of flagNames) {
            formFlags[flagName] = this.calculateFormFlag(flagName, formId);
        }

        return formFlags;
    }

    reset() {
        this.flags = {};
        this.flagScheme = [];
        this.isInitialized = false;
    }
}
